module.exports = __webpack_public_path__ + "img/20240523_tiankang.1bdb3e16.jpeg";